import { useMutation, useQueryClient } from 'react-query';
import { queryKeys } from './queryKeys';
import { TransfersListDTO, TransferDirection } from './useTransfersQuery';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { useRouteParams } from '../hooks/useRouteParams';

interface CancelTransferParams {
  transferId: string;
  transferDirection: TransferDirection;
}

const cancelTransfer = ({
  clientId,
  managedAccountId,
}: {
  clientId: string;
  managedAccountId: string;
}) => ({ transferId, transferDirection }: CancelTransferParams) =>
  authFetch('/Consumer/AchTransfers/Cancel', {
    method: 'POST',
    ...httpBodyOptions({ managedAccountId, transferId, clientId, transferDirection }, true),
  });

export const useCancelTransferMutation = (managedAccountId: string) => {
  const { clientId } = useRouteParams();

  const queryClient = useQueryClient();

  const queryKey = queryKeys.transfers({ clientId, managedAccountId });

  return useMutation(cancelTransfer({ clientId, managedAccountId }), {
    onSuccess: (_, { transferId }) => {
      queryClient.setQueryData<TransfersListDTO | undefined>(queryKey, transfersCache => {
        if (transfersCache) {
          return {
            ...transfersCache,
            pending: transfersCache.pending.filter(transfer => transfer.transferId !== transferId),
          };
        }

        return transfersCache;
      });
    },
  });
};
